import React from "react";
import { Select, MenuItem } from "@mui/material";

export default function Language(props) {
  const handleChange = (event) => {
    props.setLanguage(event.target.value);
  };
  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={props.language}
      label="Age"
      onChange={handleChange}
    >
      <MenuItem value="en">en</MenuItem>
      <MenuItem value="ru">ru</MenuItem>
      <MenuItem value="pl">pl</MenuItem>
    </Select>
  );
}
